import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.starts-with";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import dataSourcesDataMixin from './dataSourcesDataMixin';
import uuidv4 from 'uuid/v4';
import formMixin from '../formMixin';
import cloneDeep from 'lodash/cloneDeep';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
export default {
  name: 'NiotaClassicOriginatorsForm',
  components: {
    MarkdownItVueLight: MarkdownItVueLight
  },
  mixins: [formMixin, dataSourcesDataMixin],
  props: {
    editedItem: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      accounts: [],
      datasources: [],
      showActilityPassword: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    originatorFormButtons: function originatorFormButtons() {
      if (this.formItem.id) {
        return this.formCardButtons;
      }

      return [{
        icon: 'fal fa-arrow-left',
        action: 'back',
        tooltip: this.$i18n_t('Common.reset')
      }].concat(this.formCardButtons);
    },
    dataSourcesForType: function dataSourcesForType() {
      var _this = this;

      return this.datasources.filter(function (ds) {
        if (_this.formItem.type === 'Webhook') {
          return ds.type === 'webhook';
        } else if (_this.formItem.type === 'auto_id') {
          return ds.type === 'auto_id';
        } else if (_this.formItem.type === 'Filesystem') {
          return ds.type === 'filesystem';
        }

        return ['webhook', 'auto_id', 'filesystem'].indexOf(ds.type) < 0;
      });
    },
    datasourceTypes: function datasourceTypes() {
      var _this2 = this;

      return [{
        type: 'LoRaWAN',
        fields: {
          user: {
            help: this.$i18n_t('NiotaClassic.Originators.form.credentials_lorawan_text'),
            requiredRule: [function (v) {
              return _this2.selectedDatasourceType.startsWith('firefly') || !!v || _this2.$i18n_t('Common.fieldRequired');
            }]
          },
          password: {
            help: this.$i18n_t('NiotaClassic.Originators.form.credentials_lorawan_text'),
            requiredRule: [function (v) {
              return _this2.selectedDatasourceType.startsWith('firefly') || !!v || _this2.$i18n_t('Common.fieldRequired');
            }]
          },
          apiKey: {
            help: this.$i18n_t('NiotaClassic.Originators.form.apikey_firefly_text'),
            requiredRule: [function (v) {
              return !_this2.selectedDatasourceType.startsWith('firefly') || !!v || _this2.$i18n_t('Common.fieldRequired');
            }]
          }
        }
      }, {
        type: 'Sigfox',
        fields: {
          user: {
            help: this.$i18n_t('NiotaClassic.Originators.form.user_sigfox_text'),
            requiredRule: this.requiredRule
          },
          password: {
            help: this.$i18n_t('NiotaClassic.Originators.form.password_sigfox_text'),
            requiredRule: this.requiredRule
          },
          apiKey: {
            help: this.$i18n_t('NiotaClassic.Originators.form.apikey_sigfox_text'),
            requiredRule: this.requiredRule
          }
        }
      }, {
        type: 'NB-IoT',
        fields: {
          apiKey: {
            help: this.$i18n_t('NiotaClassic.Originators.form.apikey_nbiot_text'),
            requiredRule: this.requiredRule
          }
        }
      }, {
        type: 'Discovergy',
        fields: {
          user: {
            help: this.$i18n_t('NiotaClassic.Originators.form.user_discovergy_text'),
            requiredRule: this.requiredRule
          },
          password: {
            help: this.$i18n_t('NiotaClassic.Originators.form.password_discovergy_text'),
            requiredRule: this.requiredRule
          },
          polling_interval: {
            help: this.$i18n_t('NiotaClassic.Originators.form.polling_intervall_text'),
            requiredRule: this.requiredRule
          }
        }
      }, {
        type: 'Temetra',
        fields: {
          apiKey: {
            help: this.$i18n_t('NiotaClassic.Originators.form.apikey_firefly_text'),
            requiredRule: this.requiredRule
          },
          temetra_api_key: {
            help: this.$i18n_t('NiotaClassic.Originators.form.apikey_temetra_text'),
            requiredRule: this.requiredRule
          }
        }
      }, {
        type: 'Actility',
        fields: {
          target_profile: {
            requiredRule: this.requiredRule
          },
          act_login: {
            requiredRule: this.requiredRule
          },
          act_password: {
            requiredRule: this.requiredRule
          }
        }
      }, {
        type: 'Filesystem',
        fields: {
          formate: {
            help: this.$i18n_t('NiotaClassic.Originators.form.formate_text'),
            requiredRule: this.requiredRule
          },
          import_path: {
            help: this.$i18n_t('NiotaClassic.Originators.form.import_path_text'),
            requiredRule: this.requiredRule
          },
          polling_interval: {
            help: this.$i18n_t('NiotaClassic.Originators.form.polling_intervall_text'),
            requiredRule: this.requiredRule
          },
          xslt: {
            help: this.$i18n_t('NiotaClassic.Originators.form.xslt_text'),
            requiredRule: this.requiredRule
          }
        }
      }, {
        type: 'Webhook',
        fields: {
          import_api_key: {
            requiredRule: this.requiredRule
          },
          transform_template: {}
        }
      }, {
        type: 'auto_id',
        fields: {
          import_api_key: {
            requiredRule: this.requiredRule
          }
        }
      }];
    },
    selectedOriginatorType: function selectedOriginatorType() {
      return (this.dataSourcesData[this.formItem.type] || {}).name || this.formItem.type;
    },
    selectedDatasourceType: function selectedDatasourceType() {
      return (this.formItem.datasource || {}).type || '';
    },
    formConfig: function formConfig() {
      var _this3 = this;

      if (!this.formItem.type) {
        return {};
      } // if (this.$refs.form) {
      //   // re-run validation if data-source changes
      //   this.$refs.form.validate();
      // }


      return (this.datasourceTypes.find(function (config) {
        return config.type === _this3.formItem.type;
      }) || {}).fields || {};
    },
    webhookApiPath: function webhookApiPath() {
      var endpoint = this.editedItem.type === 'Webhook' ? 'packets' : 'auto-id-events';
      return "".concat(this.n1Protocol, "://").concat(this.n1Host, "/api/x/webhooks/originators/").concat(this.formItem.id || ':originator_id', "/").concat(endpoint, "?auth=").concat(this.formItem.options.import_api_key);
    }
  }),
  watch: {},
  created: function created() {
    var _this4 = this;

    this.formItem = cloneDeep(this.editedItem);

    if (!this.formItem.options) {
      this.formItem.options = {
        formate: 'xml'
      };
    }

    this.formItem.account = this.formItem.account || {}; // workaround to make the account-name being displayed from the beginning
    // it comes returned as "name1" within the object, but it is just "name" in the `accounts` list

    this.formItem.account.name = this.formItem.account.name || this.formItem.account.name1;
    this.formItem.options.import_api_key = this.formItem.options.import_api_key || uuidv4();
    NiotaClassicApiService.accountsFetchPlain().then(function (res) {
      _this4.accounts = res.data.accounts;
    }).catch(function () {
      _this4.$snack(_this4.$i18n_t('Common.errorFetchingAccounts'), 'error');
    });
    NiotaClassicApiService.dataSourcesFetchPlain().then(function (res) {
      _this4.datasources = res.data.datasources;
    }).catch(function () {
      _this4.$snack(_this4.$i18n_t('Common.errorFetchingDatasources'), 'error');
    });
  },
  methods: {
    handleDataSourceChange: function handleDataSourceChange() {
      if (this.$refs.form) {
        // re-run validation if data-source changes
        this.$refs.form.validate();
      }
    },
    copyToClipboard: function copyToClipboard(refId) {
      var element = this.$refs[refId];

      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(element.innerHTML);
      } else {
        var range;

        if (document.selection) {
          // IE
          range = document.body.createTextRange();
          range.moveToElementText(element);
          range.select();
        } else if (window.getSelection) {
          range = document.createRange();
          range.selectNode(element);
          window.getSelection().removeAllRanges();
          window.getSelection().addRange(range);
        }

        document.execCommand('copy');

        if (document.selection) {
          document.selection.empty();
        } else {
          window.getSelection().removeAllRanges();
        }
      }
    },
    updateRequest: function updateRequest() {
      this.formItem.accountId = (this.formItem.account || {}).id;
      this.formItem.datasourceId = (this.formItem.datasource || {}).id;
      return NiotaClassicApiService.originatorsUpdate(this.formItem.id, this.formItem);
    },
    createRequest: function createRequest() {
      this.formItem.accountId = (this.formItem.account || {}).id;
      this.formItem.datasourceId = (this.formItem.datasource || {}).id;
      return NiotaClassicApiService.originatorsCreate(this.formItem);
    },
    uploadImage: function uploadImage(image) {
      var _this5 = this;

      NiotaClassicApiService.uploadImage(image, 'originator').then(function (data) {
        _this5.formItem.image = data.file;
        _this5.formItem = cloneDeep(_this5.formItem);
      }).catch(function () {
        _this5.$snack(_this5.$i18n_t('Common.imageUploadError'), 'error');
      });
    }
  }
};